import { createFileRoute } from '@tanstack/react-router'
import { RouteErrorFallback } from '@/components/ErrorBoundary'
import { AgentPage } from '@/components/agent/AgentPage'

export const Route = createFileRoute('/agent/new')({
  component: AgentNewPage,
  errorComponent: RouteErrorFallback,
})

function AgentNewPage() {
  return <AgentPage mode="create" />
}
